export default __webpack_public_path__ + "static/metaimage-f8eecfe18a717707c297fe5f466f7e9c.png";